/**
 * Complete your look — complementary recommendations (intent=complementary).
 * Fetch via Section Rendering API + horizontal carousel (scroll-snap), no Flickity dependency.
 */
(function () {
  function hideSection(el) {
    var section = el && el.closest(".shopify-section");
    if (section) section.style.display = "none";
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  function parseBool(value) {
    return String(value) === "true";
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getBreakpoint() {
    var w = window.innerWidth || 0;
    if (w <= 740) return "mobile";
    if (w <= 980) return "tablet";
    return "desktop";
  }

  function isIntegerLike(value) {
    return Math.abs(value - Math.round(value)) < 0.001;
  }

  function extractInnerFromSectionHtml(text) {
    var inner = null;
    var trimmed = (text || "").trim();
    if (trimmed.indexOf("<") === 0) {
      try {
        inner = new DOMParser().parseFromString(trimmed, "text/html").querySelector(".js-complete-your-look");
      } catch (e) {
        inner = null;
      }
    }
    if (!inner) {
      var div = document.createElement("div");
      div.innerHTML = text;
      inner = div.querySelector(".js-complete-your-look");
    }
    return inner;
  }

  function initCylCarousel(root) {
    var shell = root.querySelector(".complete-your-look__carousel-shell");
    if (!shell) return;

    var viewport = shell.querySelector(".js-cyl-viewport");
    var track = shell.querySelector(".js-cyl-track");
    var cells = shell.querySelectorAll(".js-cyl-cell");
    var prev = shell.querySelector(".js-cyl-scroll-prev");
    var next = shell.querySelector(".js-cyl-scroll-next");
    if (!viewport || !track || !cells.length) return;

    if (shell.dataset.cylReady === "1") return;
    shell.dataset.cylReady = "1";

    var configuredShowArrows = parseBool(shell.dataset.cylShowArrows);
    var showArrows = configuredShowArrows;
    var autoplay = parseBool(shell.dataset.cylAutoplay);
    var autoplayMs = toNumber(shell.dataset.cylAutoplaySpeed, 4) * 1000;

    var rafId;
    var resizeHandler;
    var scrollHandler;
    var autoTimer = null;

    function getConfig() {
      var bp = getBreakpoint();
      var spvFallback = bp === "desktop" ? 4 : bp === "tablet" ? 3 : 1.5;
      var gapFallback = bp === "desktop" ? 24 : bp === "tablet" ? 20 : 16;
      var spv =
        bp === "desktop"
          ? toNumber(shell.dataset.cylSlidesDesktop, spvFallback)
          : bp === "tablet"
            ? toNumber(shell.dataset.cylSlidesTablet, spvFallback)
            : toNumber(shell.dataset.cylSlidesMobile, spvFallback);
      var gap =
        bp === "desktop"
          ? toNumber(shell.dataset.cylGapDesktop, gapFallback)
          : bp === "tablet"
            ? toNumber(shell.dataset.cylGapTablet, gapFallback)
            : toNumber(shell.dataset.cylGapMobile, gapFallback);

      // On mobile always keep a partial next card visible to suggest horizontal scroll.
      if (bp === "mobile") {
        if (isIntegerLike(spv)) {
          spv = spv + 0.2;
        }
        spv = Math.max(1.2, spv);
        showArrows = false;
      } else {
        showArrows = configuredShowArrows;
      }
      return {
        spv: Math.max(1, spv),
        gap: Math.max(0, gap)
      };
    }

    function maxScroll() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    function getStepPx() {
      var firstCell = cells[0];
      if (!firstCell) return Math.max(200, viewport.clientWidth * 0.82);
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return firstCell.getBoundingClientRect().width + gap;
    }

    function setCellLayout() {
      var config = getConfig();
      var totalGap = config.gap * (config.spv - 1);
      var cellWidth = (viewport.clientWidth - totalGap) / config.spv;
      if (!Number.isFinite(cellWidth) || cellWidth <= 0) return;

      track.style.gap = config.gap + "px";
      cells.forEach(function (cell) {
        cell.style.width = cellWidth + "px";
        cell.style.flexBasis = cellWidth + "px";
      });
    }

    function updateButtons() {
      if (!prev || !next) return;
      if (!showArrows) {
        prev.setAttribute("hidden", "");
        next.setAttribute("hidden", "");
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      var ms = maxScroll();
      if (ms <= 2) {
        prev.setAttribute("hidden", "");
        next.setAttribute("hidden", "");
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.removeAttribute("hidden");
      next.removeAttribute("hidden");
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= ms - 2;

      // Hide a control only if its rendered box is outside viewport bounds.
      window.requestAnimationFrame(function () {
        [prev, next].forEach(function (button) {
          var rect = button.getBoundingClientRect();
          var isOut = rect.left < 0 || rect.right > window.innerWidth;
          if (isOut) {
            button.setAttribute("hidden", "");
          } else {
            button.removeAttribute("hidden");
          }
        });
      });
    }

    function updateLayout() {
      setCellLayout();
      updateButtons();
    }

    function queueLayoutUpdate() {
      window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(updateLayout);
    }

    function scrollByStep(direction) {
      var step = getStepPx() * direction;
      var ms = maxScroll();
      var target = viewport.scrollLeft + step;

      if (direction > 0 && viewport.scrollLeft >= ms - 2) {
        viewport.scrollTo({ left: 0, behavior: "smooth" });
        return;
      }
      if (direction < 0 && viewport.scrollLeft <= 2) {
        viewport.scrollTo({ left: ms, behavior: "smooth" });
        return;
      }

      target = Math.max(0, Math.min(ms, target));
      viewport.scrollTo({ left: target, behavior: "smooth" });
    }

    function startAutoPlay() {
      if (!autoplay || autoplayMs < 500) return;
      stopAutoPlay();
      autoTimer = window.setInterval(function () {
        if (maxScroll() <= 2) return;
        scrollByStep(1);
      }, autoplayMs);
    }

    function stopAutoPlay() {
      if (!autoTimer) return;
      window.clearInterval(autoTimer);
      autoTimer = null;
    }

    if (prev && next) {
      prev.addEventListener("click", function () {
        scrollByStep(-1);
      });
      next.addEventListener("click", function () {
        scrollByStep(1);
      });
    }

    scrollHandler = function () {
      window.requestAnimationFrame(updateButtons);
    };
    viewport.addEventListener("scroll", scrollHandler, { passive: true });

    resizeHandler = debounce(queueLayoutUpdate, 120);
    window.addEventListener("resize", resizeHandler);

    viewport.addEventListener("mouseenter", stopAutoPlay);
    viewport.addEventListener("mouseleave", startAutoPlay);
    viewport.addEventListener("touchstart", stopAutoPlay, { passive: true });
    viewport.addEventListener("touchend", startAutoPlay, { passive: true });
    viewport.addEventListener("focusin", stopAutoPlay);
    viewport.addEventListener("focusout", startAutoPlay);

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stopAutoPlay();
      } else {
        startAutoPlay();
      }
    });

    queueLayoutUpdate();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(queueLayoutUpdate);
    });
    startAutoPlay();

    shell.__cylDestroy = function () {
      stopAutoPlay();
      window.removeEventListener("resize", resizeHandler);
      viewport.removeEventListener("scroll", scrollHandler);
    };
  }

  function refreshThemeHooks() {
    if (typeof Shopify !== "undefined" && Shopify.theme) {
      if (Shopify.theme.ajaxCart) Shopify.theme.ajaxCart.init();
      if (Shopify.theme.quickview) Shopify.theme.quickview.init();
    }
    if (typeof WAU !== "undefined" && WAU.ProductGridVideo) WAU.ProductGridVideo.init();
  }

  function loadCompleteYourLook(el) {
    if (!el || !el.classList.contains("js-complete-your-look")) return;

    if (el.querySelector(".js-cyl-viewport")) {
      initCylCarousel(el);
      return;
    }

    if (!el.dataset.baseUrl || !el.dataset.productId) return;

    var baseUrl = el.dataset.baseUrl;
    var sectionId = el.dataset.sectionId;
    var productId = el.dataset.productId;
    var limit = el.dataset.limit || "8";
    var intent = el.dataset.intent || "complementary";

    var url =
      baseUrl +
      "?section_id=" +
      encodeURIComponent(sectionId) +
      "&product_id=" +
      encodeURIComponent(productId) +
      "&limit=" +
      encodeURIComponent(limit) +
      "&intent=" +
      encodeURIComponent(intent);

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var inner = extractInnerFromSectionHtml(html);
        if (!inner || !inner.innerHTML.trim()) {
          hideSection(el);
          return;
        }
        el.innerHTML = inner.innerHTML;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            initCylCarousel(el);
            refreshThemeHooks();
          });
        });
      })
      .catch(function () {
        hideSection(el);
      });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll(".js-complete-your-look").forEach(loadCompleteYourLook);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    if (!target.querySelector(".complete-your-look-wrapper")) return;
    initAll(target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var shell = event.target.querySelector(".complete-your-look__carousel-shell");
    if (!shell || typeof shell.__cylDestroy !== "function") return;
    shell.__cylDestroy();
  });
})();

/**
 * Size guide — sidebar with page content on product page.
 */
(function () {
  var CLOSE_MS = 300;
  var activeDrawer = null;
  var activeTrigger = null;

  function lockBodyScroll() {
    document.documentElement.style.overflow = "hidden";
  }

  function unlockBodyScroll() {
    document.documentElement.style.removeProperty("overflow");
  }

  function mountDrawer(drawer) {
    if (!drawer || drawer.parentElement === document.body) return;
    drawer.__mmSizeGuideHome = drawer.parentElement;
    document.body.appendChild(drawer);
  }

  function unmountDrawer(drawer) {
    if (!drawer || !drawer.__mmSizeGuideHome) return;
    drawer.__mmSizeGuideHome.appendChild(drawer);
  }

  function finalizeClose(drawer, trigger) {
    drawer.classList.remove("is-closing");
    drawer.setAttribute("aria-hidden", "true");
    drawer.hidden = true;
    unmountDrawer(drawer);
    delete drawer.dataset.mmClosing;

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    if (activeDrawer === drawer) {
      activeDrawer = null;
      activeTrigger = null;
      unlockBodyScroll();
    }
  }

  function closeDrawer(drawer, trigger, immediate) {
    if (!drawer || drawer.dataset.mmClosing === "1") return;
    if (!drawer.classList.contains("is-open") && !immediate) return;

    if (immediate) {
      drawer.classList.remove("is-open", "is-closing");
      finalizeClose(drawer, trigger);
      return;
    }

    drawer.dataset.mmClosing = "1";
    drawer.classList.remove("is-open");
    drawer.classList.add("is-closing");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    var panel = drawer.querySelector(".mm-size-guide__panel");
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      finalizeClose(drawer, trigger);
    }

    if (panel) {
      panel.addEventListener("transitionend", function onTransitionEnd(event) {
        if (event.target !== panel || event.propertyName !== "transform") return;
        panel.removeEventListener("transitionend", onTransitionEnd);
        finish();
      });
    }

    window.setTimeout(finish, CLOSE_MS + 80);
  }

  function openDrawer(drawer, trigger) {
    if (!drawer || drawer.classList.contains("is-open") || drawer.dataset.mmClosing === "1") return;

    if (activeDrawer && activeDrawer !== drawer) {
      closeDrawer(activeDrawer, activeTrigger, true);
    }

    mountDrawer(drawer);
    drawer.hidden = false;
    drawer.classList.remove("is-closing");
    drawer.setAttribute("aria-hidden", "false");
    window.requestAnimationFrame(function () {
      drawer.classList.add("is-open");
    });

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    activeDrawer = drawer;
    activeTrigger = trigger;
    lockBodyScroll();

    var closeBtn = drawer.querySelector(".mm-size-guide__close");
    if (closeBtn) closeBtn.focus();
  }

  function initSizeGuide(root) {
    var scope = root || document;

    scope.querySelectorAll(".js-mm-size-guide:not([data-mm-size-guide-ready])").forEach(function (drawer) {
      drawer.dataset.mmSizeGuideReady = "1";

      var container = drawer.closest(".mm-size-guide");
      var trigger = container && container.querySelector(".js-mm-size-guide-open");

      drawer.querySelectorAll(".js-mm-size-guide-close").forEach(function (closeEl) {
        closeEl.addEventListener("click", function (event) {
          event.preventDefault();
          closeDrawer(drawer, trigger);
        });
      });

      drawer.addEventListener("click", function (event) {
        if (event.target.closest(".mm-size-guide__panel")) return;
        closeDrawer(drawer, trigger);
      });

      var panel = drawer.querySelector(".mm-size-guide__panel");
      if (panel) {
        panel.addEventListener("click", function (event) {
          event.stopPropagation();
        });
      }

      if (trigger) {
        trigger.addEventListener("click", function () {
          openDrawer(drawer, trigger);
        });
      }
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || !activeDrawer) return;
    closeDrawer(activeDrawer, activeTrigger);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initSizeGuide();
    });
  } else {
    initSizeGuide();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (!event.target.querySelector(".js-mm-size-guide")) return;
    initSizeGuide(event.target);
  });

  document.addEventListener("shopify:section:unload", function () {
    if (activeDrawer) {
      closeDrawer(activeDrawer, activeTrigger);
    }
  });
})();
